import { BookOpenIcon, EyeIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface MethodStep {
  n: string;
  title: string;
  icon: LucideIcon;
  text: string;
  bgClass: string;
  iconClass: string;
}

export const methodSteps: MethodStep[] = [
  {
    n: '1',
    title: 'Abre',
    icon: BookOpenIcon,
    text: 'Elige la sesión o el aspecto que quieres trabajar (técnica, táctica, física, gestión).',
    bgClass: 'bg-naranja-pale',
    iconClass: 'text-naranja'
  },
  {
    n: '2',
    title: 'Mira',
    icon: EyeIcon,
    text: 'Consulta los ejercicios, sus diagramas y las correcciones del entrenador. Todo en una página.',
    bgClass: 'bg-azul-light',
    iconClass: 'text-azul'
  },
  {
    n: '3',
    title: 'Entrena',
    icon: DumbbellIcon,
    text: 'Llévalo directamente a la pista.',
    bgClass: 'bg-naranja-pale',
    iconClass: 'text-naranja'
  }
];
